import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string | null;
}

export const InputPatientFirstName: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Patient's Legal First Name">
    {form.getFieldDecorator('givenName1', {
      initialValue: initialValue,
      rules: [
        {
          required: true,
          message: "Please enter patient's first name.",
        },
      ],
    })(<Input allowClear />)}
  </Form.Item>
);
